import { timeToMilliseconds } from '../../utils/utils';
import { SelectGroupOption } from '../general-components/select-group';

export const BROADCAST_TEXT = {
	SHOW: 'Show',
	GETTING_READY: 'Getting Ready',
	REHEARSAL: 'ShowSession',
	GO_LIVE: 'GO LIVE',
	LIVE: 'Live',
	STARTING_BROADCAST: 'Starting Broadcast',
	END_SHOW: 'END SHOW',
	SHOW_ENDED: 'Show Ended',
	ERROR: 'Error',
	RETRY: 'RETRY',
	CANCEL: 'Cancel Broadcast',

	RECORDING: 'Recording',
	STREAMING: 'Streaming',
};

export const BROADCAST_CLASS = {
	READY: 'ready',
	REHEARSAL: 'showSession',
	LOADING: 'loading',
	LIVE: 'live',
	STOPPED: 'stopped',
	ERROR: 'error',
	CANCEL: 'cancel',
};

interface RecordingOption {
	value: number;
	text: string;
	className: string;

}

export const RECORDING_OPTIONS_ARRAY: RecordingOption[] = [
	{
		value: 0,
		text: 'stream',
		className: 'stream-and-record',
	},
	{
		value: 1,
		text: 'record only',
		className: 'record',
	},
];

export const RECORDING_OPTIONS = {
	STREAM_AND_RECORD: RECORDING_OPTIONS_ARRAY[0].value,
	RECORD: RECORDING_OPTIONS_ARRAY[1].value,
};

export const RECORDING_STATE_OPTIONS: SelectGroupOption[] = RECORDING_OPTIONS_ARRAY
	.map((recordingState) => ({ label: recordingState.text, value: recordingState.value }));

// 4 hours - the max opentok allows
export const MAX_ISO_RECORDING_DURATION = timeToMilliseconds(4);
export const FIRST_ISO_ALERT_TIME = MAX_ISO_RECORDING_DURATION - timeToMilliseconds(0, 30, 1);
export const SECOND_ISO_ALERT_TIME = MAX_ISO_RECORDING_DURATION - timeToMilliseconds(0, 10, 1);
export const THIRD_ISO_ALERT_TIME = MAX_ISO_RECORDING_DURATION - timeToMilliseconds(0, 3, 1);

export const ISO_ALERT_DURATIONS = {
	[FIRST_ISO_ALERT_TIME]: timeToMilliseconds(0, 1),
	[SECOND_ISO_ALERT_TIME]: timeToMilliseconds(0, 7),
	[THIRD_ISO_ALERT_TIME]: timeToMilliseconds(0, 3),
	[MAX_ISO_RECORDING_DURATION]: timeToMilliseconds(0, 1),
};

export const ISO_ALERT_MESSAGES = {
	[FIRST_ISO_ALERT_TIME]: 'Isolated Recordings End in 30 Minutes',
	[SECOND_ISO_ALERT_TIME]: 'Isolated Recordings End in 10 Minutes',
	[THIRD_ISO_ALERT_TIME]: 'Isolated Recordings End in 3 Minutes',
	[MAX_ISO_RECORDING_DURATION]: 'Isolated Recordings have Ended',
};

export const ISO_ALERT_DESCRIPTIONS = {
	[FIRST_ISO_ALERT_TIME]: 'This will not disrupt the Stream or the Canvas Recording. [Learn More](https://help.brand.live/hc/en-us/articles/5578564006039)',
	[SECOND_ISO_ALERT_TIME]: 'This will not disrupt the Stream or the Canvas Recording. [Learn More](https://help.brand.live/hc/en-us/articles/5578564006039)',
	[THIRD_ISO_ALERT_TIME]: 'This will not disrupt the Stream or the Canvas Recording. [Learn More](https://help.brand.live/hc/en-us/articles/5578564006039)',
	[MAX_ISO_RECORDING_DURATION]: 'Your Stream and Canvas Recording will continue. Restart your steam to resume Isolated Recording. [Learn More](https://help.brand.live/hc/en-us/articles/5578564006039)',
};
